import { useEffect, useMemo, useState } from 'react';

import debounce from 'lodash/debounce';

import { SearchInput } from '@ui';

type KeywordSearchProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
};

export function KeywordSearch({ value, onChange, placeholder, disabled }: KeywordSearchProps) {
    const [inputValue, setInputValue] = useState(value);
    const debouncedOnChange = useMemo(() => debounce(onChange, 300), [onChange]);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => () => debouncedOnChange.cancel(), [debouncedOnChange]);

    return (
        <SearchInput
            value={inputValue}
            onChange={(nextValue) => {
                setInputValue(nextValue);
                debouncedOnChange(nextValue);
            }}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
}
